<script setup>
defineProps({
  active: { type: String, default: '' },
  items: { type: Array, default: () => [] },
  sheetLabel: { type: String, required: true },
});

const emit = defineEmits(['select']);
</script>

<template>
  <aside
    class="rounded-lais border border-lais-border-soft bg-white p-3 lg:sticky lg:top-4 lg:h-fit"
  >
    <span
      class="inline-flex rounded-full bg-lais-bg-soft px-2.5 py-1 text-xs font-semibold text-lais-text"
    >
      {{ sheetLabel }}
    </span>
    <nav
      class="mt-3 flex gap-2 overflow-x-auto pb-1 lg:flex-col"
      role="tablist"
    >
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        role="tab"
        :aria-selected="active === item.id"
        class="flex min-h-10 shrink-0 items-center gap-2 rounded-lais px-3 py-2 text-left text-sm font-medium transition lg:w-full"
        :class="
          active === item.id
            ? 'bg-lais-primary text-white'
            : 'text-lais-text hover:bg-lais-bg-soft'
        "
        @click="emit('select', item.id)"
      >
        <i
          class="text-base"
          :class="
            active === item.id || !item.complete
              ? 'i-lucide-pencil'
              : 'i-lucide-check text-emerald-600'
          "
        />
        <span>{{ item.label }}</span>
      </button>
    </nav>
  </aside>
</template>
